import { motion } from "framer-motion";
import { CLIENTS } from "@/lib/site";
import { fadeUp } from "@/lib/anim";

export const Clients = () => {
  return (
    <section id="clients" data-testid="clients-section" className="border-b border-line bg-ink-900">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-4 mb-10">
          <span className="h-2 w-2 bg-acid rotate-45" />
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/50">
            Trusted by teams across Canberra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-line">
          {CLIENTS.map((c, i) => (
            <motion.div
              key={c.name}
              data-testid={`client-${i}`}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className={`group py-10 md:py-14 md:px-8 border-b border-line ${
                i !== 0 ? "md:border-l md:border-line" : ""
              }`}
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/35 mb-3">
                {String(i + 1).padStart(2, "0")} — {c.note}
              </p>
              <h3 className="font-display font-black tracking-tighter leading-none text-4xl md:text-5xl text-white/80 group-hover:text-acid transition-colors duration-300">
                {c.name}
              </h3>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 text-white/40 text-sm max-w-xl leading-relaxed">
          A small selection of the Canberra venues that count on Insight Cleaning Co. — displayed with their permission.
        </p>
      </div>
    </section>
  );
};
